import { render, staticRenderFns } from "./ClaimRegister.vue?vue&type=template&id=dbd3befe&"
import script from "./ClaimRegister.vue?vue&type=script&lang=js&"
export * from "./ClaimRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports